// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const AiApiSpec_errorSchema = z.object({
  message: z.optional(z.coerce.string()),
});
